'use strict'

const RADIX = 10;

// Commentoid Utiltis Library
const AppLib = {
   scaleFormatNumber: function scaleFormatNumber (message, decimals) {
      var value = message;
      var isValueNegative = (value < 0);
      (decimals > 2) ? decimals = 2 : decimals;
      (value < 0) ? value = Math.abs(value): value;
      var valueScaledString = '';
      var scaleBuckets = ['', 'K', 'M', 'B', 'T', 'P', 'E', 'Z', 'Y'];
      if (value > -1000 && value < 1000) {
         var val = Math.round(value);
         return val.toString(RADIX);
      } else {
         var valueRoundedLength = Math.round(value).toString(RADIX).length;
         var valueBase10Magnitude = parseInt((valueRoundedLength - 1)/3, 10);
         var scaleTo = Math.pow(10, valueBase10Magnitude * 3);
         var fixedDecimals = (value/scaleTo).toFixed(decimals);
         // Handle toFixed rounding up to "1000" unit
         var fixedLeftValue = parseInt(fixedDecimals, 10);
         if (fixedLeftValue === 1000) {
            valueBase10Magnitude = valueBase10Magnitude + 1; 
            fixedDecimals = "1.0";
         }
         valueScaledString = fixedDecimals + scaleBuckets[valueBase10Magnitude];
         return (!isValueNegative) ? valueScaledString : '-' + valueScaledString;
      }
   }
}

module.exports = AppLib;


//////////////////
// WEBPACK FOOTER
// ./library/applib.js
// module id = dTEU
// module chunks = 1